import React from 'react';

import Add from './Add';
import List from './List';

export default function Index() {
  return (
    <>
      <Add />
      <List />
    </>
  );
}
